export const PASSWORD_STRENGTH_COLORS = ['#EC3B6C', '#FF7A3D', '#14A79F', '#0B7A4F']

export const PASSWORD_STRENGTH_LABELS = ['Muy débil', 'Débil', 'Buena', 'Muy segura']

export const PASSWORD_HINT = 'Mínimo 8 caracteres, con mayúsculas, minúsculas y un número.'

/** De 0 a 4: longitud ≥ 8, mayúsculas y minúsculas, un número y un símbolo. */
export const passwordStrength = (value: string | null | undefined) => {
    if (!value) return 0
    return [
        value.length >= 8,
        /[A-Z]/.test(value) && /[a-z]/.test(value),
        /\d/.test(value),
        /[^A-Za-z0-9]/.test(value),
    ].filter(Boolean).length
}

export const passwordStrengthLabel = (strength: number) => PASSWORD_STRENGTH_LABELS[strength - 1] || PASSWORD_STRENGTH_LABELS[0]
